import { render, staticRenderFns } from "./WizardRenderer.vue?vue&type=template&id=01d4c7c2&scoped=true"
import script from "./WizardRenderer.vue?vue&type=script&lang=js"
export * from "./WizardRenderer.vue?vue&type=script&lang=js"
import style0 from "./WizardRenderer.vue?vue&type=style&index=0&id=01d4c7c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d4c7c2",
  null
  
)

export default component.exports